module.exports = __webpack_public_path__ + "static/media/logo.ad729fcb.png";